import { Routes } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { AboutComponent } from "./about/about.component";
import { ContactComponent } from "./contact/contact.component";
import { PolicyComponent } from "./policy/policy.component";
import { ProductComponent } from "./product/product.component";
import { ProductOrderComponent } from "./product-order/product-order.component";
import { AddOrderComponent } from "./add-order/add-order.component";
import { RegistrationComponent } from "./registration/registration.component";
import { PaymentComponent } from "./payment/payment.component";
import { MyaccountComponent } from "./myaccount/myaccount.component";

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'about', component: AboutComponent, title: 'Madhuram: About' },
    { path: 'product', component: ProductComponent, title: 'Madhuram: Products' },
    { path: 'policy', component: PolicyComponent, title: 'Madhuram: Privacy Policy' },
    { path: 'contact', component: ContactComponent, title: 'Madhuram: Contact' },
    { path: 'checkout', component: ProductOrderComponent, title: 'Madhuram: Checkout' },
    { path: 'add-order', component: AddOrderComponent, title: 'Madhuram: Order' },
    { path: 'registration', component: RegistrationComponent, title: 'Madhuram: Registration' },
    { path: 'payment', component: PaymentComponent, title: 'Madhuram: Payment' },
    { path: 'myaccount', component: MyaccountComponent, title: 'Madhuram: Accounts' },

    { path: '**', redirectTo: '', pathMatch: 'full' }
];
